module.exports = __webpack_public_path__ + "img/momo-01.d443b0d9.png";